/** Shared shell for every dashboard widget: consistent header, loading, and error states. */

import React from "react";
import { SkeletonRows } from "@/components/Skeleton";

interface WidgetCardProps {
  title: string;
  isLoading?: boolean;
  error?: string | null;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export default function WidgetCard({
  title,
  isLoading = false,
  error = null,
  action,
  children,
}: WidgetCardProps): React.ReactElement {
  return (
    <div className="widget-card">
      <div className="flex items-center justify-between">
        <h3 className="text-xs font-medium uppercase tracking-wide text-mist-400">{title}</h3>
        {action}
      </div>
      {isLoading ? (
        <SkeletonRows rows={2} />
      ) : error ? (
        <p className="text-sm text-signal-rose">{error}</p>
      ) : (
        children
      )}
    </div>
  );
}
